import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { PCSpecs } from "./components/pcspecs";
import { About } from "./components/about";
import { Patreon } from "./components/patreon";
import { Gallery } from "./components/gallery";
import { BuyMeAPickle } from "./components/buymeapickle";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Patreon data={landingPageData.Patreon} />
      <Gallery data={landingPageData.Gallery} />
      <Team data={landingPageData.Team} />
      <PCSpecs data={landingPageData.PCSpecs} />
      <BuyMeAPickle data={landingPageData.BuyMeAPickle} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
